import { DateTime } from 'luxon'
import * as moment from 'moment'
import * as R from 'ramda'

export const html2Text = (str: string) => {
  return `${str.replace(/<br\s*\/?>/gi, '\n')}`
}
export const text2Html = (str: string) => {
  return `${str}`.replace(/(?:\r\n|\r|\n)/g, '\n')
}

export const getPlaybackRate = (idx: number) => {
  const playbacks = [1.0, 1.5, 2.0, 0.5]
  return playbacks[idx % playbacks.length]
}

export const getDuration = (m: moment.Moment) => {
  let duration = ''
  const diff = moment.duration(moment().diff(m) / 1000, 'second')
  if (diff.years()) {
    duration = `${diff.years()} 年前`
  } else if (diff.months()) {
    duration = `${diff.months()} 月前`
  } else if (diff.weeks()) {
    duration = `${diff.weeks()} 週前`
  } else if (diff.days()) {
    duration = `${diff.days()} 天前`
  } else if (diff.hours()) {
    duration = `${diff.hours()} 小時前`
  } else if (diff.minutes()) {
    duration = `${diff.minutes()} 分鐘前`
  } else if (diff.seconds()) {
    duration = `${diff.seconds()} 秒前`
  } else {
    duration = `不到一秒前`
  }
  return duration
}
export const toggleElement = (element: any, elements: any[]) =>
  R.contains(element, elements)
    ? R.without(element, elements)
    : R.append(element, elements)

export const enum LectureStatus {
  Unknown = '未知',
  Fundraising = '預購中',
  Success = '熱賣中',
  Processing = '進行中',
  Finish = ''
}

export const getLectureStatus = (lecture: ILecture | null) => {
  let status = 'N/A'
  if (lecture) {
    const soldAt = DateTime.fromJSDate(lecture.soldAt.toDate())
    const startedAt = DateTime.fromJSDate(lecture.startedAt.toDate())
    const endedAt = DateTime.fromJSDate(lecture.endedAt.toDate())
    const dt = DateTime.local()
    if (dt < soldAt) {
      status = LectureStatus.Fundraising
    } else if (dt < startedAt) {
      status = LectureStatus.Success
    } else if (dt < endedAt) {
      status = LectureStatus.Processing
    } else {
      status = LectureStatus.Finish
    }
  }
  return status
}

export const getCarrierType = (carrierType: string) => {
  switch (carrierType) {
    case '1':
      return '儲存在 Qraft，中獎將自動寄信通知'
    case '2':
      return '自然人憑證條碼'
    case '3':
      return '手機條碼'
    default:
      return '未知載具'
  }
}

export const getPaymentType = (paymentType: PaymentType) => {
  switch (paymentType) {
    case 'VACC':
      return 'ATM 轉帳'
    case 'CREDIT':
      return '信用卡'
    case 'BARCODE':
      return '超商代繳'
    default:
      return '系統匯入'
  }
}

export const getContentType = (metadata: { contentType: string }) =>
  metadata.contentType ? R.split('/')(metadata.contentType)[0] : null



// WEBPACK FOOTER //
// ./src/utils/index.ts